import type { PostImageSize, PostImageType } from '~/api/types'

export function getPostImage(image: PostImageType, size?: PostImageSize) {
  const { url, width, height, formats } = image.data.attributes

  return {
    url: size ? formats[size].url : url,
    width: size ? formats[size].width : width,
    height: size ? formats[size].height : height,
  }
}
